import modalMixin from '../../mixins/_modal';
import showStaticHtml from '../../components/_show_static_html';

/**
 * プレビューのコンポーネント
 */
export default {
    name: 'preview',
    template: '#preview_component_template',
    data() {
        return {
            // タイトル
            title: null,
            // ページ設定データ
            page_data: {},
        };
    },
    computed: {
        // フリースペースデータがセットされているか
        hasPageData: function () {
            return (Object.keys(this.page_data).length > 0);
        },
    },
    mixins: [
        modalMixin,
    ],
    components: {
        // 静的HTMLを表示するコンポーネント
        'show-static-html': showStaticHtml,
    },
    methods: {
        // プレビューを開く
        show: function (title, pageData) {
            this.title = title;
            this.page_data = pageData;
            this.open();
        },
    }
};

